import { render, staticRenderFns } from "./BetslipDeleteButton.vue?vue&type=template&id=03b9f778"
import script from "./BetslipDeleteButton.vue?vue&type=script&lang=js"
export * from "./BetslipDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports